import { uuidv7 } from "uuidv7"

import { AnonymousIdBuf } from "~/classes/generated/entity"

import { addUuidToBuf, parseUuidBuf } from "./id"

export function parseAnonymousIdBuf(buf: AnonymousIdBuf) {
  const key = parseUuidBuf(buf.id()!)
  return key.toString()
}

export function createAnonIdBuf(builder: DatagramBufferBuilder, requestId?: string) {
  const uuid = requestId ?? uuidv7()
  const id = addUuidToBuf(builder, uuid)
  return AnonymousIdBuf.createAnonymousIdBuf(builder, id)
}
